// Language utility functions
import i18n from '../i18n';
import { getLanguageFromStorage, setLanguageInStorage } from './languageStorage';

/**
 * Change language and save to storage
 */
export const changeLanguage = (language: string): void => {
  i18n.changeLanguage(language);
  setLanguageInStorage(language);
  
  // Update document direction
  const htmlElement = document.documentElement;
  if (language.startsWith("ar")) {
    htmlElement.setAttribute("dir", "rtl");
  } else {
    htmlElement.setAttribute("dir", "ltr");
  }
};

/**
 * Toggle between English and Arabic
 */
export const toggleLanguage = (currentLanguage: string): string => {
  const newLanguage = currentLanguage === 'en' ? 'ar' : 'en';
  changeLanguage(newLanguage);
  return newLanguage;
};

/**
 * Get current language from i18n instance
 */
export const getCurrentLanguage = (): string => {
  return i18n.language || getLanguageFromStorage();
};

/**
 * Check if current language is Arabic
 */
export const isArabic = (): boolean => {
  return getCurrentLanguage().startsWith('ar');
};

/**
 * Check if current language is English
 */
export const isEnglish = (): boolean => {
  return getCurrentLanguage().startsWith('en');
}; 